import React from 'react';
import { Ship, FileCheck, Globe, BarChart3, Download } from 'lucide-react';

export default function OmnixLanding() {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      {/* 1. Navigation */}
      <nav className="flex justify-between items-center px-6 md:px-10 py-6 border-b border-gray-100">
        <div className="flex items-center gap-3">
          {/* Logo.png Integration */}
          <img 
            src="/Logo.png" 
            alt="Omnix Suppliers Logo" 
            className="h-10 w-auto object-contain"
            onError={(e) => (e.target.style.display = 'none')} // Hides if file is missing
          />
          {/* <span className="text-2xl font-black tracking-tighter text-blue-900 italic">
            OMNIX SUPPLIERS
          </span> */}
        </div>
        
        <a 
          href="mailto:contact@omnixsuppliers.com" 
          className="bg-blue-900 text-white px-6 py-2 rounded-full font-bold hover:bg-blue-800 transition"
        >
          Contact Us
        </a>
      </nav>

      {/* 2. Hero Section */}
      <header className="px-6 md:px-10 py-20 bg-gradient-to-br from-slate-50 to-blue-50 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <span className="bg-blue-100 text-blue-700 px-4 py-1 rounded-full text-sm font-bold uppercase tracking-widest">
            Government Supply Partner
          </span>
          <h1 className="text-5xl md:text-6xl font-extrabold text-slate-900 mt-6 leading-tight">
            Seamless <span className="text-blue-700 underline">Import</span> Solutions.
          </h1>
          <p className="text-xl text-slate-600 mt-6 leading-relaxed">
            Omnix Suppliers bridges the gap between global manufacturers and government requirements. We handle the heavy lifting of import logistics and tender compliance.
          </p>
        </div>

        <div className="relative">
          <div className="bg-white p-8 rounded-2xl shadow-2xl border border-slate-100 relative z-10">
            <div className="flex justify-between items-center mb-6">
              <h3 className="font-bold text-lg">Active Govt Import Quotas</h3>
              <FileCheck className="text-green-500" />
            </div>
            <div className="space-y-4">
              {[
                { name: 'Medical Equipment', origin: 'Germany', status: 'In Transit' },
                { name: 'Industrial Steel', origin: 'Turkey', status: 'Customs' },
                { name: 'Raw Chemicals', origin: 'India', status: 'Approved' }
              ].map((item, i) => (
                <div key={i} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                  <div>
                    <p className="font-bold text-sm">{item.name}</p>
                    <p className="text-xs text-slate-400">{item.origin}</p>
                  </div>
                  <span className="text-[10px] font-bold bg-white px-2 py-1 rounded border border-slate-200 uppercase">
                    {item.status}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="absolute -top-4 -right-4 w-full h-full bg-blue-900/10 rounded-2xl -z-0"></div>
        </div>
      </header>

      {/* 3. Core Features */}
      <section className="px-6 md:px-10 py-24">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="p-8 bg-white border border-slate-100 rounded-2xl">
            <div className="w-14 h-14 bg-blue-50 text-blue-900 rounded-xl flex items-center justify-center mb-6">
              <Globe size={28} />
            </div>
            <h4 className="text-xl font-bold mb-3">Global Sourcing</h4>
            <p className="text-slate-500 text-sm leading-relaxed">Direct partnerships with verified manufacturers across EU, Asia, and North America.</p>
          </div>

          <div className="p-8 bg-white border border-slate-100 rounded-2xl">
            <div className="w-14 h-14 bg-blue-50 text-blue-900 rounded-xl flex items-center justify-center mb-6">
              <BarChart3 size={28} />
            </div>
            <h4 className="text-xl font-bold mb-3">Tender Compliance</h4>
            <p className="text-slate-500 text-sm leading-relaxed">Detailed documentation and licensing specifically formatted for government audit standards.</p>
          </div>

          <div className="p-8 bg-white border border-slate-100 rounded-2xl">
            <div className="w-14 h-14 bg-blue-50 text-blue-900 rounded-xl flex items-center justify-center mb-6">
              <Download size={28} />
            </div>
            <h4 className="text-xl font-bold mb-3">Import Logistics</h4>
            <p className="text-slate-500 text-sm leading-relaxed">Real-time tracking from port of origin to final government delivery points.</p>
          </div>
        </div>
      </section>

      {/* 4. Simple Footer */}
      <footer className="bg-slate-900 text-white px-6 md:px-10 py-12 text-center md:text-left">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 border-b border-slate-800 pb-8">
          <div>
            <h4 className="text-xl font-bold">OMNIX SUPPLIERS</h4>
            <p className="text-slate-400 text-sm mt-2">© 2026 International Trade & Supply Co.</p>
          </div>
          <div className="text-slate-400 text-sm">
            Contact: info@omnixsuppliers.com
          </div>
        </div>
      </footer>
    </div>
  );
}